import React, { useContext } from 'react';

import classNames from 'classnames';
import { Table } from 'react-super-responsive-table';

import { TableDirection } from '../../../../types';
import { TableContext } from '../../../context/TableContext';
import { useResponsiveWidth } from '../../../hooks/useResponsiveWidth';

import * as classes from './style.module.scss';

export const CustomTable: React.FC = ({ children, ...props }) => {
  const [ref, measuredRef, widerThanParent] = useResponsiveWidth();
  const direction = useContext(TableContext);

  return (
    <div className={classNames(classes.root, classes.overflow)} ref={ref}>
      <Table
        {...props}
        ref={measuredRef}
        className={classNames(classes.table, {
          [classes.horizontal]:
            (direction === TableDirection.Auto && !widerThanParent) ||
            direction === TableDirection.Horizontal,
          [classes.vertical]:
            (direction === TableDirection.Auto && widerThanParent) ||
            direction === TableDirection.Vertical,
        })}
      >
        {children}
      </Table>
    </div>
  );
};
